import React, { useState } from "react";
import styles from "./statisticDashboard.module.css";
import StatisticTabBar from "../StatisticTabbar/statisticTabBar";
import Statistic1 from "./statistic1";
import Statistic2 from "./statistic2";
// import Statistic3 from "./statistic3";
// import Statistic4 from "./statistic4";
import Statistic5 from "./statistic5";
// import Statistic6 from "./statistic6";
// import Statistic7 from "./statistic7";
// import Statistic8 from "./statistic8";
import Statistic9 from "./statistic9";
import Statistic10 from "./statistic10";


export default function StatisticTabbar() {

    const tabs = [
        { id: "st1", label: "Statistik 1" },
        { id: "st2", label: "Statistik 2" },
        // { id: "st3", label: "Statistik 3" },
        // { id: "st4", label: "Statistik 4" },
        { id: "st5", label: "Statistik 3" },
        // { id: "st6", label: "Statistik 6" },
        // { id: "st7", label: "Statistik 7" },
        // { id: "st8", label: "Statistik 8" },
        { id: "st9", label: "Statistik 4" },
        { id: "st10", label: "Statistik 5" },
    ];

    const [activeTab, setActiveTab] = useState<string>(tabs[0].id);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className={styles.container}>
            <StatisticTabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

            <div className={styles.tabContent}>
            {activeTab === "st1" && <Statistic1 />}
            {activeTab === "st2" && <Statistic2 />}
            {/* {activeTab === "st3" && <Statistic3 />}
            {activeTab === "st4" && <Statistic4 />} */}
            {activeTab === "st5" && <Statistic5 />}
            {/* {activeTab === "st6" && <Statistic6 />}
            {activeTab === "st7" && <Statistic7 />}
            {activeTab === "st8" && <Statistic8 />} */}
            {activeTab === "st9" && <Statistic9 />}
            {activeTab === "st10" && <Statistic10 />}
       
            </div>
            
        </div>
    );
};


